import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { CalendarMeetingInfoDtoType } from '@/api/generated';
import Meeting from '@/components/Meeting/Meeting';
import useSharedMeeting from '@/hooks/useSharedMeeting';
import PageContainer from '@/pages/PageContainer';
import { useSelectedMeetingsActions } from '@/store/selectedMeetingsStore';

const SharedMeeting = () => {
  const { sharedMeetingId } = useParams();
  const { sharedMeetingData } = useSharedMeeting(undefined, sharedMeetingId!);
  const { setSelectedMeetings, clearSelectedMeetings } = useSelectedMeetingsActions();

  useEffect(() => {
    if (sharedMeetingData?.meeting) {
      setSelectedMeetings([
        {
          id: sharedMeetingData.meeting.id,
          sharedMeetingId,
          transcript: sharedMeetingData.meeting.transcript,
          title: sharedMeetingData.meeting.title,
          startTime: sharedMeetingData.meeting.startTime,
          type: CalendarMeetingInfoDtoType.privateShared
        }
      ]);
    }
    return () => {
      clearSelectedMeetings();
    };
  }, [sharedMeetingData?.meeting]);

  return (
    <PageContainer>
      <Meeting
        sharedMeeting
        event={sharedMeetingData?.event}
        meetingRecordingUrl={sharedMeetingData?.recordingUrl}
        meetingTranscriptUrl={sharedMeetingData?.transcriptUrl}
        meeting={sharedMeetingData?.meeting}
        meetingAnalysis={sharedMeetingData?.meetingAnalysis?.[0]}
      />
    </PageContainer>
  );
};

export default SharedMeeting;
